import { useMediaQuery, useTheme, Tooltip } from "@mui/material";
import TableCellMui from "@mui/material/TableCell";
import {
  TABLE_COLOR_BORDER,
  TABLE_COLOR_BORDER_HEADER,
} from "../../../utils/colors";
import Box from "@mui/material/Box";

const TableCell = ({
  children,
  align = "left",
  isHeader = false,
  indexRow,
  colSpan = 0,
  onClick = () => {},
  dataTour = "",
  customColor = "",
  isSticky = false,
  stickyPosition = "right", // "left" or "right"
  stickyOffset = 0, // Offset for multiple sticky columns
  sx = {},
  isLastRow = false,
  showLastRowBorder = false,
  showTooltip = false,
  tooltipComponent = null,
  sxContainerTooltip = {},
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const isStickyCell = isSticky && !isMobile;

  const getBackgroundColor = () => {
    if (customColor) {
      return customColor;
    }
    if (isHeader) {
      return theme?.palette?.table?.header?.background || "#F9FAFB";
    }

    if (indexRow % 2 === 0) {
      return theme?.palette?.table?.cell?.backgroundEven || "#fff";
    }
    return theme?.palette?.table?.cell?.backgroundOdd || "#fff";
  };

  const getTextColor = () => {
    if (isHeader) {
      return "#000";
    }
    return "#000";
  };

  const backgroundColor = getBackgroundColor();
  const color = getTextColor();

  const sxSticky = isStickyCell
    ? {
        position: "sticky",
        [stickyPosition]: stickyOffset,
        zIndex: sx?.zIndex ?? (isHeader ? 1000 : 999),
        backgroundColor: backgroundColor,
      }
    : {};

  const commonSx = {
    padding: "10px 8px !important",
    minWidth: sx?.minWidth || "130px",
    backgroundColor: backgroundColor,
    color,
    fontSize: theme.typography.body2.fontSize,
    fontWeight: isHeader && 600,
    whiteSpace: "nowrap",
    wordBreak: "keep-all",
    overflow: "hidden",
    textOverflow: "ellipsis",
    borderBottom:
      isLastRow && !showLastRowBorder
        ? "none"
        : `1px solid ${isHeader ? TABLE_COLOR_BORDER_HEADER : TABLE_COLOR_BORDER}`,
    height: isHeader ? 55 : 70,
    cursor: "pointer",
    ...sx,
    ...sxSticky,
  };

  if (showTooltip) {
    return (
      <TableCellMui
        data-tour={dataTour}
        align={align}
        colSpan={colSpan}
        onClick={onClick}
        sx={commonSx}
      >
        <Tooltip
          title={tooltipComponent || children}
          arrow
          PopperProps={{
            sx: {
              zIndex: 9999,
            },
          }}
        >
          <Box
            sx={{
              ...sxContainerTooltip,
              whiteSpace: "nowrap",
              wordBreak: "keep-all",
              overflow: "hidden",
              textOverflow: "ellipsis",
              display: "inline-block",
            }}
          >
            {children}
          </Box>
        </Tooltip>
      </TableCellMui>
    );
  }

  return (
    <TableCellMui
      data-tour={dataTour}
      align={align}
      colSpan={colSpan}
      onClick={onClick}
      sx={commonSx}
    >
      {children}
    </TableCellMui>
  );
};

export default TableCell;
